
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foerderung/foerderfinder",
      function () {
        return require("private-next-pages/foerderung/foerderfinder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foerderung/foerderfinder"])
      });
    }
  